import { combineActions, handleActions } from 'redux-actions';

import { actions as coreActions } from '@formue-app/core';

import { actions } from './actions';

export { actions };

const { apiClients } = coreActions.entities;

// What the API clients pages need back from the sagas.
export const defaultState = {
  // The list was refused (403): the session predates `api-clients:manage`.
  forbidden: false,
  // JSON:API errors of the last create or update the API rejected.
  errors: [],
  // The client the last create made, for the new-client page to open.
  createdId: null,
  // `{ id, clientSecret }`: the secret the API shows only once, on its way to
  // the client's page, which takes it out of the store. Never in the entity
  // cache.
  secret: null,
};

const keepNewSecret = (state, { payload }) => ({
  ...state,
  secret: payload.secret || state.secret,
});

export const reducer = handleActions(
  {
    [apiClients.indexRequestSuccess]: (state) => ({
      ...state,
      forbidden: false,
    }),
    [apiClients.indexRequestFailure]: (state, { payload }) => ({
      ...state,
      forbidden: payload.error?.status === 403,
    }),
    [apiClients.createRequestBegin]: (state) => ({
      ...state,
      errors: [],
      createdId: null,
    }),
    [apiClients.updateRequestBegin]: (state) => ({ ...state, errors: [] }),
    [combineActions(
      apiClients.createRequestFailure,
      apiClients.updateRequestFailure
    )]: (state, { payload }) => ({ ...state, errors: payload.errors || [] }),
    [apiClients.createRequestSuccess]: (state, action) => ({
      ...keepNewSecret(state, action),
      createdId: action.payload.result['api-clients'][0],
    }),
    [combineActions(
      apiClients.updateRequestSuccess,
      apiClients.rotateRequestSuccess
    )]: keepNewSecret,
    [combineActions(actions.clear, 'APP/FLUSH')]: () => defaultState,
  },
  defaultState
);
